import { Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';

import BackButton from '@swf/components/StarsModal/components/BackButton';

import type { CardViewProps } from '../../config/NotificationTypes';
import sharedStyle from '../../styles/shared.scss';

import styles from './BackStyles.scss';

const CardBackTemplate: React.FC<CardViewProps> = ({
  viewConfig: { title },
  onToggleFlip,
  children
}) => (
  <>
    <header className={styles.moreInfoHeader}>
      <BackButton onClick={onToggleFlip} />
      <Translation {...title.tag} />
    </header>
    <div className={classNames(styles.moreInfoContent, sharedStyle.notificationBody)}>
      {children}
    </div>
  </>
);

export default CardBackTemplate;
